import { ExpandTransition, FadeTransition } from '@bam/transitions'
import { useBreakpoints } from '@vueuse/core'
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { Navigation, Pagination, Parallax } from 'swiper'
import 'swiper/css'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { createApp, nextTick } from 'vue'
import "./scss/global.scss"

window.gsap = gsap;
gsap.registerPlugin(ScrollTrigger);

import * as ANIMATIONS from './animations'

if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
}

function scrollToHash() {
    const hash = window.location.hash;
    if (hash.length <= 1) return;
    const el = document.getElementById(decodeURIComponent(hash.substring(1)));
    if (el) el.scrollIntoView(true);
}

window.addEventListener("pageshow", (e) => {
    if (e.persisted) scrollToHash();
});

const app = createApp({
    data: () => {
        return {
            navigationOpen: false,
            globalSwiperModules: [
                Navigation,
                Pagination,
                Parallax,
            ],
        };
    },

    mounted() {
        // ANIMATIONS.initMenus();
        // ANIMATIONS.initHeader();
        // ANIMATIONS.initStickySocial();
        ANIMATIONS.initPinnedMedia();
        ANIMATIONS.initCards();
        // ANIMATIONS.initIconList();
        // ANIMATIONS.initTextMedia();

        ANIMATIONS.initElementMovement();
        // ANIMATIONS.initFuiContainer();

        nextTick(() => {
            ScrollTrigger.refresh();
            scrollToHash();
        });
    },

    methods: {
        toggleNavigation() {
            this.navigationOpen = !this.navigationOpen;
        },
    },
});

const bps = JSON.parse(getComputedStyle(document.body).getPropertyValue('--bam-breakpoints').replaceAll("'", ''));
const breakpoints = useBreakpoints(bps);
app.provide('breakpoints', breakpoints);
app.config.globalProperties.$breakpoints = breakpoints;

const components = import.meta.glob('./components/**/*.vue', { eager: true })
Object.entries(components).forEach(([ path, definition ]) => {
    const componentName = path.split('/').pop().replace(/\.\w+$/, '')
    app.component(componentName, definition.default)
});

app.component('swiper', Swiper);
app.component('swiper-slide', SwiperSlide);
app.component('expand-transition', ExpandTransition);

app.mount('#app');

// Die Seite wird per {% cache %} statisch ausgeliefert – damit landen auch der
// CSRF-Token und die Captcha-Werte des Formulars im Cache und wären für alle
// Besucher identisch. Formie verwirft solche Absendungen als Spam.
//
// refreshForCache() zieht diese Werte pro Besucher nach: CSRF-Token, JavaScript-
// und Duplicate-Captcha sowie den Unload-Hash. Die Captcha-Inputs legt Formie
// erst asynchron an, deshalb wartet die Funktion intern per waitForElement()
// auf sie – ein eigener querySelector direkt nach dem fetch läuft ins Leere.
//
// Siehe cms/vendor/verbb/formie/docs/template-guides/cached-forms.md
document.addEventListener('onFormieInit', (event) => {
    event.detail.formie.refreshForCache(event.detail.formId);
});


// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept();
}
